import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const assignOrderUUID = createUUID();

export default function useConfirmedOrderActions({
  id: orderId,
  modifiedOn,
  onRefresh,
}) {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();


  const assignOrder = () => {
    stateManager.run(async () => {
      const response = await taskService.order.assign({
        orderId,
        modifiedOn,
        toastMessageConfig: {
          success: { text: "Order assigned successfully" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        onRefresh();
      }
    }, assignOrderUUID);
  };

  return {

    isLoading,
    assignOrder,

  };
}
